<template>
  <div class="home-wrapper" :class="{ kk_lang: i18n().locale === 'kk' }">
    <div class="container">
      <transition name="fade">
        <card-modal v-if="showModal" @toggleModal="toggleModal" />
      </transition>

      <div class="banner">
        <div class="banner-info">
          <div class="banner-info__glow"></div>
          <div class="banner-info__stroke"></div>
          <div class="banner-info__text">
            <span>{{ $t("banner.text") }}</span>
          </div>
        </div>
        <div class="banner-title">
          <h1 v-html="$t('banner.title')"></h1>
          <img src="@/assets/images/18+.png" alt="18+" />
        </div>
        <h3 v-html="$t('banner.subtitle')"></h3>
        <img src="@/assets/images/18+.png" alt="18+" />
      </div>

      <div class="card-block">
        <div class="cards">
          <div class="portal">
            <img src="@/assets/images/portal.png" alt="portal" />
          </div>
          <div class="cards__wrapper">
            <div class="cards__wrapper__video">
              <video
                autoplay
                muted
                loop
                playsinline
                preload="auto"
                style="pointer-events: none"
              >
                <source v-if="isSafari" :src="rmLeftVideo" type="video/mp4" />
                <source src="../assets/video/rm_l.webm" type="video/webm" />
              </video>
            </div>
            <div class="cards__wrapper__video">
              <video
                autoplay
                muted
                loop
                playsinline
                preload="auto"
                style="pointer-events: none"
              >
                <source v-if="isSafari" :src="rmRightVideo" type="video/mp4" />
                <source src="../assets/video/rm_r.webm" type="video/webm" />
              </video>
            </div>
          </div>
        </div>
        <div class="cards-logos">
          <img src="@/assets/images/mastercard.png" alt="mastercard" />
          <img src="@/assets/images/visa.png" alt="visa" />
        </div>
        <div class="cards-info">
          <img src="@/assets/images/coin.png" alt="coin" />
          <p>{{ $t("cards.text") }}</p>
          <a
            :href="'https://bankffin.kz/' + i18n().locale + '/res/mobile-app'"
            class="get-card__btn-border"
          >
            <div class="get-card__btn">
              {{ $t("global.get-card") }}
            </div>
          </a>
        </div>
      </div>

      <div class="originality content">
        <h2 v-html="$t('originality.title')"></h2>
        <div class="originality__content">
          <div class="originality__content-top">
            <div class="originality__text-border">
              <div class="originality__text">
                <div class="originality__gradient"></div>
                <h4>{{ $t("originality.text.title") }}</h4>
                <p>{{ $t("originality.text.subtitle") }}</p>
                <div class="originality__text-notice">
                  {{ $t("originality.text.notice") }}
                </div>
                <video
                  autoplay
                  muted
                  loop
                  playsinline
                  preload="auto"
                  style="pointer-events: none"
                >
                  <source v-if="isSafari" :src="movVideo" type="video/mp4" />
                  <source src="../assets/video/cards.webm" type="video/webm" />
                </video>
              </div>
            </div>
            <div class="originality__qr-border">
              <div class="originality__qr">
                <div class="originality__qr-top">
                  <img src="@/assets/images/originality/logo.png" alt="logo" />
                  <p>{{ $t("originality.qr.open-card") }}</p>
                </div>
                <div class="originality__qr-bottom">
                  <img src="@/assets/images/qr.png" alt="qr code" />
                  <p>{{ $t("originality.qr.scan") }}</p>
                </div>
                <div class="originality__qr-mobile-btns">
                  <a
                    :href="
                      'https://bankffin.kz/' + i18n().locale + '/res/mobile-app'
                    "
                    target="_blank"
                    class="originality__qr-mobile-btn"
                  >
                    <img src="@/assets/images/app-store.svg" alt="app store" />
                    <span>App Store</span>
                  </a>
                  <a
                    :href="
                      'https://bankffin.kz/' + i18n().locale + '/res/mobile-app'
                    "
                    target="_blank"
                    class="originality__qr-mobile-btn"
                  >
                    <img
                      src="@/assets/images/google-play.svg"
                      alt="play market"
                    />
                    <span>Play Market</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="originality__content-bottom">
            RICK AND MORTY and all related characters and elements © & ™ Cartoon
            Network (s24)
          </div>
        </div>
      </div>

      <div class="benefit content">
        <h2 v-html="$t('benefit.title')"></h2>
        <div class="benefit__content">
          <div class="benefit__left">
            <div class="benefit__gradient"></div>
            <h4>{{ $t("benefit.content.title1") }}</h4>
            <p>{{ $t("benefit.content.subtitle1") }}</p>
            <div class="benefit__btn-wrapper">
              <div class="benefit__btn" @click="toggleModal(true)">
                {{ $t("benefit.content.btn") }}
              </div>
            </div>
          </div>
          <div class="benefit__right">
            <div class="benefit__right-top">
              <div class="benefit__gradient"></div>
              <h4>{{ $t("benefit.content.title2") }}</h4>
              <p>{{ $t("benefit.content.subtitle2") }}</p>
            </div>
            <div class="benefit__right-bottom">
              <div class="benefit__right-bottom__left">
                <div class="benefit__gradient"></div>
                <h4>{{ $t("benefit.content.title3") }}</h4>
                <p>{{ $t("benefit.content.subtitle3") }}</p>
              </div>
              <div class="benefit__right-bottom__right">
                <div class="benefit__gradient"></div>
                <h4>{{ $t("benefit.content.title4") }}</h4>
                <p>{{ $t("benefit.content.subtitle4") }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="benefit__mobile">
          <VueSlickCarousel
            ref="benefitSlider"
            class="benefit-slider"
            :focusOnSelect="true"
            v-bind="benefitSliderSettings"
          >
            <div class="benefit__mobile-slide">
              <h4>{{ $t("benefit.content.title1") }}</h4>
              <p>{{ $t("benefit.content.subtitle1") }}</p>
              <div class="benefit__btn-wrapper">
                <div class="benefit__btn" @click="toggleModal(true)">
                  {{ $t("benefit.content.btn") }}
                </div>
              </div>
            </div>
            <div class="benefit__mobile-slide">
              <h4>{{ $t("benefit.content.title2") }}</h4>
              <p>{{ $t("benefit.content.subtitle2") }}</p>
            </div>
            <div class="benefit__mobile-slide">
              <h4 v-html="$t('benefit.content.title3-mobile')"></h4>
              <p>{{ $t("benefit.content.subtitle3") }}</p>
            </div>
            <div class="benefit__mobile-slide">
              <h4>{{ $t("benefit.content.title4") }}</h4>
              <p>{{ $t("benefit.content.subtitle4") }}</p>
            </div>
          </VueSlickCarousel>
        </div>
        <div class="benefit__info">
          <img src="@/assets/images/info-icon.svg" alt="i" />
          <span>{{ $t("benefit.info") }}</span>
        </div>
      </div>
    </div>

    <HowItWorks />
    <div class="container">
      <div class="instruction content">
        <h2 v-html="$t('instruction.title')"></h2>
        <div class="instruction__content">
          <div class="instruction__items">
            <div
              class="instruction__item-border"
              :class="{ active: instruction.id === currentInstructionId }"
              @mouseover="currentInstructionId = instruction.id"
              v-for="instruction in instructions"
              :key="instruction.id"
            >
              <div class="instruction__item">
                <div class="instruction__item-number">
                  <span>{{ instruction.id }}</span>
                </div>
                <div class="instruction__item-text">
                  <h5>{{ $t(instruction.title) }}</h5>
                  <p v-if="instruction.description">
                    {{ $t(instruction.description) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="instruction__img">
            <img
              :src="
                require(`@/assets/images/instruction/${
                  currentInstruction.img
                }_${i18n().locale}.png`)
              "
              alt=""
            />
          </div>
        </div>
        <div class="instruction__mobile">
          <VueSlickCarousel
            ref="imgSlider"
            class="img-slider"
            :asNavFor="textSlider"
            :focusOnSelect="true"
            v-bind="imgSliderSettings"
          >
            <div
              v-for="instruction in instructions"
              :key="instruction.id"
              class="instruction__mobile-img"
            >
              <img
                :src="
                  require(`@/assets/images/instruction/${instruction.img}_${
                    i18n().locale
                  }.png`)
                "
                alt=""
              />
            </div>
          </VueSlickCarousel>
          <VueSlickCarousel
            ref="textSlider"
            class="text-slider"
            :asNavFor="imgSlider"
            :focusOnSelect="true"
            v-bind="textSliderSettings"
          >
            <div
              v-for="instruction in instructions"
              :key="instruction.id"
              class="slider-text-item__border"
            >
              <div class="slider-text-item">
                <div class="slider-text-item__count">
                  <span>{{ instruction.id }}</span>
                </div>
                <h5>{{ $t(instruction.title) }}</h5>
                <p v-if="instruction.description">
                  {{ $t(instruction.description) }}
                </p>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
      </div>

      <div class="qr">
        <div class="qr-text">
          <h3>{{ $t("qr.title") }}</h3>
          <p>{{ $t("qr.subtitle") }}</p>
          <div class="qr-block__wrapper">
            <div class="qr-block">
              <img src="@/assets/images/qr.png" alt="qr" />
              <div class="qr-block__text">{{ $t("qr.block-text") }}</div>
            </div>
          </div>
          <div class="qr-buttons">
            <a
              :href="'https://bankffin.kz/' + i18n().locale + '/res/mobile-app'"
              target="_blank"
              class="qr-btn"
            >
              <img src="@/assets/images/app-store.svg" alt="app store" />
              <span>App Store</span>
            </a>
            <a
              :href="'https://bankffin.kz/' + i18n().locale + '/res/mobile-app'"
              target="_blank"
              class="qr-btn"
            >
              <img src="@/assets/images/google-play.svg" alt="play market" />
              <span>Play Market</span>
            </a>
          </div>
        </div>
      </div>
      <possible-risks-block />
      <div class="faq content">
        <h2 v-html="$t('faq.title')"></h2>
        <div class="faq-list">
          <faq-item
            :header="$t('faq.item1.header')"
            :content="$t('faq.item1.content')"
          >
          </faq-item>
          <faq-item
            :header="$t('faq.item2.header')"
            :content="$t('faq.item2.content')"
          >
          </faq-item>
          <faq-item
            :header="$t('faq.item3.header')"
            :content="$t('faq.item3.content')"
          >
          </faq-item>
          <faq-item
            :header="$t('faq.item4.header')"
            :content="$t('faq.item4.content')"
          >
          </faq-item>
          <faq-item
            :header="$t('faq.item5.header')"
            :content="$t('faq.item5.content')"
          >
          </faq-item>
          <faq-item
            :header="$t('faq.item6.header')"
            :content="$t('faq.item6.content')"
          >
          </faq-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import FaqItem from "@/components/FaqItem.vue";
import CardModal from "@/components/CardModal.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import movVideo from "@/assets/video/cards.mov";
import rmLeftVideo from "@/assets/video/rm_l.mov";
import rmRightVideo from "@/assets/video/rm_r.mov";
import HowItWorks from "@/components/HowItWorks.vue";
import PossibleRisksBlock from '@/components/PossibleRisksBlock.vue';

export default {
  name: "HomeView",
  data() {
    return {
      isIOSorMacOS: /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform),
      propositionInfo: false,
      aboutInfo: false,
      showModal: false,
      currentInstructionId: 1,
      movVideo,
      rmLeftVideo,
      rmRightVideo,
      instructions: [
        {
          id: 1,
          title: "instruction.title1",
          description: "instruction.subtitle1",
          img: "1",
        },
        {
          id: 2,
          title: "instruction.title2",
          description: "instruction.subtitle2",
          img: "2",
        },
        {
          id: 3,
          title: "instruction.title4",
          description: "instruction.subtitle4",
          img: "4",
        },
        {
          id: 4,
          title: "instruction.title5",
          img: "5",
        },
      ],
      benefitSliderSettings: {
        dots: true,
        arrows: false,
        edgeFriction: 0.35,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
      },
      imgSlider: undefined,
      textSlider: undefined,
      imgSliderSettings: {
        dots: false,
        arrows: false,
        edgeFriction: 0.35,
        infinite: false,
        speed: 500,
        fade: true,
        slidesToShow: 1,
      },
      textSliderSettings: {
        dots: true,
        arrows: false,
        edgeFriction: 0.35,
        infinite: false,
        speed: 500,
        fade: true,
        slidesToShow: 1,
      },
    };
  },
  computed: {
    currentInstruction() {
      return this.instructions.find(
        (item) => item.id === this.currentInstructionId
      );
    },
    isSafari() {
      let userAgentString = navigator.userAgent;
      let chromeAgent = userAgentString.indexOf("Chrome") > -1;
      let safariAgent = userAgentString.indexOf("Safari") > -1;

      if (chromeAgent && safariAgent) safariAgent = false;

      return safariAgent;
    },
  },
  components: {
    HowItWorks,
    CardModal,
    PossibleRisksBlock,
    FaqItem,
    VueSlickCarousel,
  },
  mounted() {
    let self = this;

    setTimeout(function () {
      self.imgSlider = self.$refs.imgSlider;
      self.textSlider = self.$refs.textSlider;
    }, 100);

    window.onpageshow = function () {
      let videos = document.querySelectorAll("video");

      videos.forEach(function (video) {
        video.play();
      });
    };

    this.glowAnimation();
  },
  watch: {
    showModal(val) {
      if (val) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
      }
    },
  },
  methods: {
    i18n() {
      return i18n;
    },
    toggleModal(data) {
      this.showModal = data;
    },
    glowAnimation() {
      let x = 11,
        y = 0,
        valueX = 1,
        valueY = 2;

      let glow = document.querySelector(".banner-info__glow"),
        stroke = document.querySelector(".banner-info__stroke");

      setInterval(function () {
        if (x === 90 && y < 100) {
          valueX = -1;
          y += valueY;
        } else if (x === 10 && y > 0) {
          valueX = 1;
          y += valueY;
        } else if (y === 100) {
          valueY = -2;
          x += valueX;
        } else if (y === 0) {
          valueY = 2;
          x += valueX;
        }

        glow.style.background =
          "radial-gradient(25% 40% at " +
          x +
          "% " +
          y +
          "%, rgb(255, 255, 255) 0%, rgba(255, 255, 255, 0) 100%)";
        stroke.style.background =
          "radial-gradient(18.3344% 45.3822% at " +
          x +
          "% " +
          y +
          "%, rgb(255, 255, 255) 0%, rgba(255, 255, 255, 0) 100%)";
      }, 20);
    },
  },
};
</script>
